import {
  SET_WP_CATEGORY_LABELS,
  SET_WP_CATEGORY_IMGINFO,
  // 壁纸--精选
  SET_WP_BANNER_LIST,
  SET_WP_RECOMMEND_LIST,
  SET_WP_DETAIL_LIST,
  SET_WP_DETAIL_RECO_BANNER,
  SET_WP_RECO_BANNER,
  SET_WP_RECO_GROUP,
  SET_WP_RANK_MORE,
  SET_WP_OPTERAYTION,
  SET_WP_SCREEN_LIST,
  WP_UPDATE_PREVIEW,
  WP_ADD_DOWNLOAD_IMG,
  WP_REMOVE_DOWNLOAD_IMG,
  WP_UPDATE_STATUS_DOWNLOAD_IMG,
  WP_UPDATE_PROGRESS_DOWNLOAD_IMG,
  WP_DOWNLOAD_ING,
  WP_DOWNLOAD_FAILED,
  // 壁纸 作者列表
  SET_WP_AUTHOR_LIST,
  // 壁纸 作家作品集
  SET_WP_AUTHOR_SHOWREEL,
  SET_WP_CATEGORY_STATUS,
  SET_SCROLL,
  CLEAR_WALLPPER_LIST,
  SET_WP_PRODUCT_INFO,
  WP_PAY_DOWNLOAD_COUNT,
  WP_SET_SHOW_ORDER,
  WP_SET_SHOW_TURN_START,
  WP_SET_SHOW_TURN_STOP,
  WP_SET_SHOW_TURN_LIMIT,
  SET_WP_BATCH_SHOW,
  SET_BATCH_INFO,
  HIDE_BATCH_ADD,
  EMPTY_BTNADD,
} from '../constants/wallpaper';

const initState = {
  scroll: {
    mineScrollTop: null,
    categoryScrollTop: null,
    recommendScrollTop: null,
    rankScrollTop: null,
    authorListScrollTop: null,
    authorScrollTop: null,
  },
  wpDetailList: {},
  wpDetailReco: {},
  rankList: {
    list: [],
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
    },
    load: null,
  },
  recoBanners: {},
  recoGroups: [],
  bannerList: [],
  recommendInfo: {
    list: [],
    name: '',
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
    },
    load: false,
  },
  labelList: [],
  categoryInfo: {
    pagenation: {
      skip: 0,
      limit: 54,
      count: 0,
      tagId: '-1',
      colorId: '-1',
      classId: '-1',
    },
    list: [],
    load: false,
    status: {
      classStatus: 'collapse',
      tagStatus: 'collapse',
    },
  },
  wpScreen: {
    load: false,
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
    },
    list: [],
  },
  wpOpteration: {
    load: false,
  },
  wpPreviewInfo: {
    isShow: false,
  },
  wpDowloadImgs: [],
  wpAuthorList: {
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
    },
    list: [],
    load: false,
  },
  wpAuthorShowreel: {
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
      authorId: null,
    },
    list: [],
    load: false,
  },
  wpProductDetail: {
    //壁纸产品详细信息
    show: false,
  },
  // 下载壁纸张数计数
  wpPayDownCount: {},
  wpShowOrder: {
    show: false,
    wallpaperId: '',
    rankId: '',
    wpType: 1, // 1:单张壁纸，2:壁纸包， 3:仅仅订阅
    scenetype: 'other', // 'set', 'dl', 'resident', 'loop_single', 'loop_batch', 'loop_start'
  }, // 展示下订单弹框
  wpShowTurnStart: {
    show: false,
  },
  wpShowTurnStop: {
    show: false,
  },
  wpShowTurnLimit: {
    show: false,
  },
  wpBatchAddShow: {
    isShow: false,
    isChange: false,
    groupType: null,
    classifyId: null,
    tagId: null,
  }, // 批量添加轮播按钮是否展现
  wpBatchInfoShow: false, // 批量添加轮播按钮内容是否展现
};

const wallpaper = (state = initState, action = {}) => {
  let tmp;
  let wallpaperId;
  switch (action.type) {
    case CLEAR_WALLPPER_LIST:
      // 清除某些壁纸list数据，解决一个bug
      return {
        ...state,
        rankList: {
          list: [],
          pagenation: {
            skip: 0,
            limit: 48,
            count: 0,
          },
          load: null,
        },
        wpAuthorShowreel: {
          pagenation: {
            skip: 0,
            limit: 48,
            count: 0,
            authorId: null,
          },
          list: [],
          load: false,
        },
        bannerList: [],
      };
    case SET_SCROLL:
      return {
        ...state,
        scroll: {
          ...state.scroll,
          ...action.payload,
        },
      };
    case SET_WP_DETAIL_LIST:
      return { ...state, wpDetailList: action.payload };
    case SET_WP_DETAIL_RECO_BANNER:
      return { ...state, wpDetailReco: action.payload };
    case SET_WP_RANK_MORE:
      return { ...state, rankList: action.payload };
    case SET_WP_RECO_BANNER:
      return { ...state, recoBanners: action.payload };
    case SET_WP_RECO_GROUP:
      return { ...state, recoGroups: action.payload };
    case SET_WP_BANNER_LIST:
      return {
        ...state,
        bannerList: action.payload,
      };
    case SET_WP_RECOMMEND_LIST:
      return {
        ...state,
        recommendInfo: { ...state.recommendInfo, ...action.payload },
      };
    case SET_WP_CATEGORY_LABELS:
      return {
        ...state,
        labelList: action.payload,
      };
    case SET_WP_CATEGORY_IMGINFO:
      return {
        ...state,
        categoryInfo: { ...state.categoryInfo, ...action.payload },
      };
    case SET_WP_OPTERAYTION:
      return {
        ...state,
        wpOpteration: {
          ...state.wpOpteration,
          ...action.payload,
        },
      };
    case SET_WP_SCREEN_LIST:
      return {
        ...state,
        wpScreen: {
          ...state.wpOpteration,
          ...action.payload,
        },
      };
    case WP_UPDATE_PREVIEW:
      return { ...state, wpPreviewInfo: action.info };
    // 添加更新下载任务
    case WP_ADD_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      tmp = state.wpDowloadImgs.find(v => v.wallpaperId === wallpaperId);
      // 去重
      if (tmp) {
        if (tmp.status === WP_DOWNLOAD_FAILED) {
          tmp.status = WP_DOWNLOAD_ING;
          tmp.averagespeed = 0;
          tmp.progress = 0;
          tmp.taskid = null;
          tmp.path = null;
          tmp.type = action.wallpaper.type;
          return { ...state, wpDowloadImgs: [...state.wpDowloadImgs] };
        }
        return state;
      }
      return { ...state, wpDowloadImgs: [...state.wpDowloadImgs, action.wallpaper] };
    // 删除下载任务
    case WP_REMOVE_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      tmp = state.wpDowloadImgs.filter(v => v.wallpaperId !== wallpaperId);
      return { ...state, wpDowloadImgs: tmp };
    // 更改下载任务某个任务状态
    case WP_UPDATE_STATUS_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      state.wpDowloadImgs.some(v => {
        if (v.wallpaperId === wallpaperId) {
          const tmpObj = v;
          tmpObj.status = action.wallpaper.status;
          tmpObj.taskid = action.wallpaper.taskid;
          tmpObj.averagespeed = action.wallpaper.averagespeed || 0;
          tmpObj.path = action.wallpaper.path;
          tmpObj.type = action.wallpaper.type;
          if (action.wallpaper.status === 1) {
            tmpObj.progress = 0;
          } else if (action.wallpaper.status === 2) {
            tmpObj.progress = 100;
          }
          return true;
        }
        return false;
      });
      return { ...state, wpDowloadImgs: [...state.wpDowloadImgs] };
    case WP_UPDATE_PROGRESS_DOWNLOAD_IMG:
      wallpaperId = action.wallpaper.wallpaperId || action.wallpaper.id;
      state.wpDowloadImgs.some(v => {
        if (v.wallpaperId === wallpaperId) {
          const tmpObj = v;
          tmpObj.progress = action.wallpaper.progress || 0;
          tmpObj.downloadSpeed = action.wallpaper.DownloadSpeed;
          tmpObj.averagespeed = action.wallpaper.AverageDownloadSpeed;
          return true;
        }
        return false;
      });
      return { ...state, wpDowloadImgs: [...state.wpDowloadImgs] };
    // 壁纸 作家列表
    case SET_WP_AUTHOR_LIST:
      return { ...state, wpAuthorList: { ...state.wpAuthorList, ...action.payload } };
    // 壁纸 作家作品列表
    case SET_WP_AUTHOR_SHOWREEL:
      return { ...state, wpAuthorShowreel: { ...state.wpAuthorShowreel, ...action.payload } };
    case SET_WP_CATEGORY_STATUS: {
      return {
        ...state,
        categoryInfo: {
          ...state.categoryInfo,
          status: {
            ...state.categoryInfo.status,
            ...action.payload,
          },
        },
      };
    }
    case SET_WP_PRODUCT_INFO:
      return {
        ...state,
        wpProductDetail: {
          ...state.wpProductDetail,
          ...action.payload,
        },
      };
    case WP_PAY_DOWNLOAD_COUNT:
      const type = action.payload.type || 'delete';
      const payload = action.payload || {};
      delete payload.type;
      const tempCount =
        type === 'delete'
          ? {}
          : {
              ...state.wpPayDownCount,
              ...payload,
            };
      return {
        ...state,
        wpPayDownCount: tempCount,
      };

    // 是否显示订单页面 8.5
    case WP_SET_SHOW_ORDER:
      return {
        ...state,
        wpShowOrder: { ...action.payload },
      };
    // 显示第一次设置轮播弹框 8.5
    case WP_SET_SHOW_TURN_START:
      return {
        ...state,
        wpShowTurnStart: { ...action.payload },
      };
    // 显示第一次设置轮播弹框 8.5
    case WP_SET_SHOW_TURN_STOP:
      return {
        ...state,
        wpShowTurnStop: { ...action.payload },
      };
    // 显示第一次设置轮播弹框 8.5
    case WP_SET_SHOW_TURN_LIMIT:
      return {
        ...state,
        wpShowTurnLimit: { ...action.payload },
      };

    // 是否显示批量添加轮播按钮
    case SET_WP_BATCH_SHOW:
      let wpObj = JSON.parse(JSON.stringify(state.wpBatchAddShow));
      let change = false;
      if (action.groupType !== wpObj.groupType) {
        change = true;
      } else {
        change = false;
        if (
          action.classifyId === null &&
          action.tagId === null &&
          action.classifyId === wpObj.classifyId &&
          action.tagId === wpObj.tagId
        ) {
          change = false;
        } else {
          change = true;
        }
      }
      return {
        ...state,
        wpBatchAddShow: {
          isShow: action.hasCarousel === 0 ? true : false,
          isChange: change,
          groupType: action.groupType,
          classifyId: action?.classifyId ?? null,
          tagId: action?.tagId ?? null,
        },
        wpBatchInfoShow: action.isShow,
      };
    // 是否展开批量添加轮播按钮内容
    case SET_BATCH_INFO:
      return {
        ...state,
        wpBatchInfoShow: action.payload,
      };
    // 隐藏批量添加按钮
    case HIDE_BATCH_ADD:
      return {
        ...state,
        wpBatchAddShow: false,
      };
    case EMPTY_BTNADD:
      return {
        ...state,
        wpBatchAddShow: {
          isShow: false,
          isChange: false,
          groupType: null,
          classifyId: null,
          tagId: null,
        },
      };
    default:
      return state;
  }
};

export default wallpaper;
